import { useEffect, useState } from "react";
import PieKBGU from "./Pie/Pie";
import styles from "./styles.module.scss";
import Photo from "../../../assets/images/meal.png";
import Icon from "../../../assets/images/logoLeft.png";

type PhotoType = string;

export const Kbgu = () => {
  const [proteins, setProteins] = useState<{ value: number }[]>([]);
  const [lipids, setLipids] = useState<{ value: number }[]>([]);
  const [carbs, setCarbs] = useState<{ value: number }[]>([]);
  const [calories, setCalories] = useState<{ value: number }[]>([]);
  const [photo, setPhoto] = useState<PhotoType>("");
  const [mealDescription, setMealDescription] = useState<string>("");
  const [mealTitle, setMealTitle] = useState<string>("");
  const [meal, setMeal] = useState<string>("");

  useEffect(() => {
    const data = [
      [{ value: 7 }, { value: 4 }],
      [{ value: 9 }, { value: 2 }],
      [{ value: 3 }, { value: 8 }],
      [{ value: 600 }, { value: 2700 }],
    ];
    setProteins(data[0]);
    setLipids(data[1]);
    setCarbs(data[2]);
    setCalories(data[3]);
    setPhoto(Photo);
    setMealDescription(
      "тарелка геркулесовой каши, приготовленной на молоке со свежей голубикой"
    );
    setMealTitle("Геркулесовая каша с голубикой");
    setMeal("Завтраки");
  }, []);

  return (
    <div className={styles.gridcontainer}>
      <div className={styles.infocontainer}>
        {photo && <img className={styles.photo} src={photo} alt="meal" />}
        <h3 className={styles.infotitle}>{mealTitle}</h3>
        <h3 className={styles.info}>На фото - {mealDescription}</h3>
        <div className={styles.input}> {meal}</div>
      </div>
      <div className={styles.normcontainer}>
        <div className={styles.title}>Норма (усредненная)</div>
        <ul>
          <li className={styles.item}>Белки</li>
          <li className={styles.item}>Жиры</li>
          <li className={styles.item}>Углеводы</li>
          <li className={styles.item}>Калории</li>
        </ul>
      </div>
      <div className={styles.proteins}>
        <PieKBGU
          data={proteins}
          colors={["#D21E1E", "rgba(194, 102, 102, 1)"]}
          centerText="Белки"
          centerSubText="11г"
          photo={Icon}
        />
      </div>
      <div className={styles.lipids}>
        <PieKBGU
          data={lipids}
          colors={["#D2D21E", "#4d4d21ff"]}
          centerText="Жиры"
          centerSubText="15г"
          photo={Icon}
        />
      </div>
      <div className={styles.carbons}>
        <PieKBGU
          data={carbs}
          colors={[" #1EB1D2", "#2a4f58ff"]}
          centerText="Углеводы"
          centerSubText="15г"
          photo={Icon}
        />
      </div>
      <div className={styles.calories}>
        <PieKBGU
          data={calories}
          colors={[" #1ED22A", "#29542cff"]}
          centerText="Калории"
          centerSubText="3000ккал"
          photo={Icon}
        />
      </div>
    </div>
  );
};
